<script setup lang="ts">
withDefaults(defineProps<{
    hasActions?: boolean
}>(), {
    hasActions: false,
});
</script>

<template>
    <div class="tab-content">
        <div class="tab-pane active">
            <div v-if="hasActions && $slots.actions" class="tab-actions">
                <slot name="actions"></slot>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>
.tab-pane {
    padding: 15px;
}
.tab-actions {
    border-bottom: solid 1px var(--light-emphasis-lighter);
    margin: -15px -5px 10px;
    padding: 10px;
}
</style>
